import { Link, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import { DevRoleSwitcher } from "./components/DevRoleSwitcher";
import { Badge, Spinner } from "./components/ui";
import { ContractListPage } from "./features/contracts/ContractListPage";
import { NewContractPage } from "./features/contracts/NewContractPage";
import { AuditLogPage } from "./features/audit/AuditLogPage";
import { ROLE_LABELS } from "./masters";
import { t } from "./i18n/zh-TW";

function Header() {
  const { user } = useAuth();
  const isManagement = user?.role === "secretariat" || user?.role === "gm";
  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-baseline gap-2">
            <span className="text-lg font-bold text-brand-700">{t.appTitle}</span>
            <span className="text-xs text-slate-400">{t.appSubtitle}</span>
          </Link>
          {user && (
            <nav className="flex items-center gap-3 text-sm">
              <Link to="/" className="text-slate-600 hover:text-brand-700">
                {t.nav.list}
              </Link>
              {isManagement && (
                <Link to="/audit" className="text-slate-600 hover:text-brand-700">
                  {t.nav.audit}
                </Link>
              )}
            </nav>
          )}
        </div>
        {user && (
          <div className="flex items-center gap-3 text-sm">
            <span className="text-slate-600">
              {user.name}
              <span className="ml-1 text-slate-400">／{user.department}</span>
            </span>
            <Badge tone="blue">{ROLE_LABELS[user.role] ?? user.role}</Badge>
          </div>
        )}
      </div>
    </header>
  );
}

function Shell() {
  const { loading, error, user } = useAuth();

  return (
    <div className="min-h-full">
      <DevRoleSwitcher />
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-8">
        {loading ? (
          <div className="py-16">
            <Spinner label={t.common.loading} />
          </div>
        ) : error || !user ? (
          <div className="rounded-2xl border border-red-200 bg-red-50 px-6 py-10 text-center text-red-700">
            {error ?? t.errors.notLoggedIn}
          </div>
        ) : (
          <Routes>
            <Route path="/" element={<ContractListPage />} />
            <Route path="/new" element={<NewContractPage />} />
            <Route path="/audit" element={<AuditLogPage />} />
          </Routes>
        )}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
